export interface SubMenuItemType {
  key: string;
  text: string;
  onClick: () => void;
}

interface SubMenuProps {
  selectedKey: string;
  items: SubMenuItemType[];
}

const SubMenu: React.FC<SubMenuProps> = ({ selectedKey, items }) => {
  return (
    <div className="flex h-9 flex-shrink-0 border-0 border-b border-solid border-b-base-border-default px-[var(--spacing-lg)]">
      {items.map((item) => (
        <div key={item.key} className="flex flex-1 flex-col items-center justify-between pt-[var(--spacing-sm)]" onClick={item.onClick}>
          <span className={`typography-headline-md ${item.key === selectedKey ? 'text-base-txt-primary' : 'text-base-txt-disabled'}`}>{item.text}</span>
          {item.key === selectedKey && <div className="h-[2px] w-6 rounded-t-[2px] bg-base-ic-primary" />}
        </div>
      ))}
    </div>
  );
};

export default SubMenu;
